/* eslint-disable no-console */
<template>
  <div>
    <div class="main_unit" style="display: flex;justify-content: center;" v-if="!isInitLoading">
      <pulse-loader class="w-100 text-center" :loading="isLoading"></pulse-loader>
      <div class="dashboard_List_tbl_unit tbl_bg_blue" >

        <div v-if="validationMessage" class="mgt_20 mgb_20 mgl_20">
          <Message :validationMessage="validationMessage" />
        </div>
        <div v-if="apivalidationMessage" class="mgt_20 mgb_20 mgl_20">
          <Message :validationMessage="apivalidationMessage" />
        </div>

        <table>
          <tbody>
          <tr class="text-center">
            <th class="wd350 alertList_text_align">店舗名</th>
            <th class="alertList_text_align" style="width:120px" rowspan="2">健康身だしなみ</th>
            <th v-for="menu in cookingCheckMenuList" :key="menu['importantButtonId']" class="alertList_text_align" style="width:120px;white-space:normal;word-break: break-word;word-wrap: break-word;" rowspan="2" >
              {{ menu['lowerButtonName'] }}</th>
          </tr>
          <tr>
            <th class="border_top_none"><input class="wd150" type="text" v-model="searchWord" placeholder="キーワード検索"> </th>
          </tr>

          <tr v-for="(alertList, index) in filteredDatas" :key="index">
            <td class="tbl_tex_left_pd5 text_white_space">{{alertList.storeName}}</td>
            <td class="alertList_text_align dashboard_staff_kanri_box">
              <a href="#" @click.prevent.stop="csvOutputHealth(alertList.id)">CSV出力</a>
            </td>
            <td v-for="menu in cookingCheckMenuList" :key="menu['importantButtonId']" class="alertList_text_align dashboard_staff_kanri_box">
              <a href="#" @click.prevent.stop="csvOutputCooking(alertList.id,menu['buttonNo'])">CSV出力</a>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="overlay" v-show="showContentCsv">
      <div>
        <div class="modal_box wd512">
          <div class="modal_header_unit">
            <div class="modal_header_box">
              <p class="modal_header_tit">CSV出力</p>
            </div>
          </div>
          <div class="modal_content_tex">
            <p>CSV出力が完了しました。</p>
          </div>

          <div class="btn_submit">
            <a href="#" @click.prevent.stop="closeModelCsv">OK</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Message from '@/app/components/Message.vue'
import PulseLoader from '@/app/components/PulseLoader.vue'

export default {
  name: 'DashboardCookingHealthList',
  components: {
    Message,
    PulseLoader
  },
  props: {
    startDate: String,
    endDate: String,
  },
  computed:{
    brandPath: function () {
      return this.$store.getters['brand/path']
    },
    filteredDatas:function(){
      var data = this.alertListData;
      var filterWord = this.searchWord && this.searchWord.toLowerCase();
      if(filterWord){
        data = data.filter(function (row){
          return Object.keys(row).some(function (){
            return String(row["storeName"]).toLowerCase().includes(filterWord)
          })
        })
      }

      return data;

    },
    areaId: function () {
      return this.$store.getters['dashboard/selectedAreaId']
    },
  },
  data: function () {
    return {
      isInitLoading:false,
      validationMessage:"",
      apivalidationMessage:"",
      alertMessage:'入力エラーがあります。',
      alertListData:[],
      cookingCheckMenuList:[],
      showContentCsv:false,
      isLoading:false,
      searchWord:'',
      csvResponseData: [],
    }
  },
  created: function(){
    this.calc();
  },
  methods: {
    calc:async function() {

      this.isInitLoading = true;
      this.validationMessage = "";
      this.apivalidationMessage = "";

      // 企業ブランドIDの取得
      this.brandId = this.$store.getters['brand/id']
      const params = {
        start_date: this.startDate,
        end_date: this.endDate,
        areaId: this.areaId,
      };

      // DBデータ取得
      await this.$axios
          .get(this.$apiEndpoint + 'manage/brand/' + this.brandId + '/dashboard/cookingHealthList', {params})
          .then(response => {
            this.alertListData = response['data']['storeList'];
            this.cookingCheckMenuList = response['data']['cookingCheckMenuList'];
          })
          .catch((err) => {
            let error = {
              button: {
                path: {name: 'top', params: {brandPath: this.brandPath}}
              }
            }
            if (err.customError) {
              error = Object.assign(error, err.customError)
            }
            this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
          }).finally(() => this.isInitLoading = false);
    },
    async csvOutputHealth(id) {
      this.isLoading = true;
      this.validationMessage = "";
      this.apivalidationMessage = "";
      let brandId = this.$store.getters['brand/id'];
      let storeId = id;
      const params = {
        start_date: this.startDate,
        end_date: this.endDate,
      };
      await this.$axios
          .get(this.$apiEndpoint + 'manage/brand/'+ brandId +'/store/' + storeId + '/report/csv/health', {params})
          .then(response => (this.csvResponseData = response))
          .catch((err) => {
            let error = {
              button: {
                path: {name: 'top', params:{brandPath: this.brandPath}}
              }}
            if (err.customError) {
              error = Object.assign(error, err.customError);

              if(error.code == 400){
                this.apivalidationMessage =  error.message;
              } else if (error.code == 401) {
                //店舗管理者のtokenエラーの場合
                this.$cookies.set('user-api-token', '', 0)
                this.$store.dispatch('store/doClear')
              }
            }
            if(error.code !== 400){
              this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
            }
          }).finally(()=> this.isLoading = false);
      if(!this.commonDownloadCSV(this.csvResponseData)){
        this.apivalidationMessage =  "CSVの出力に失敗しました。";
      }
      else{
        this.showContentCsv = true;
      }
    },
    async csvOutputCooking(id, buttonId) {
      this.isLoading = true;
      this.validationMessage = "";
      this.apivalidationMessage = "";
      let brandId = this.$store.getters['brand/id'];
      let storeId = id;
      const params = {
        start_date: this.startDate,
        end_date: this.endDate,
      };

      await this.$axios
          .get(this.$apiEndpoint + 'manage/brand/' + brandId + '/store/' + storeId + '/dashboard/csv/cooking/' + buttonId, {params})
          .then(response => (this.csvResponseData = response))
          .catch((err) => {
            let error = {
              button: {
                path: {name: 'top', params:{brandPath: this.brandPath}}
              }}
            if (err.customError) {
              error = Object.assign(error, err.customError);

              if(error.code == 400){
                this.apivalidationMessage =  error.message;
              }
            }
            if(error.code !== 400){
              this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
            }
          }).finally(()=> this.isLoading = false);

      if(!this.commonDownloadCSV(this.csvResponseData)){
        this.apivalidationMessage =  "CSVの出力に失敗しました。";
      }
      else{
        this.showContentCsv = true;
      }
    },
    closeModelCsv() {
      this.showContentCsv = false;
    },
  }
}
</script>
